import { startScroll, stopScroll } from "../utils/scroll-config";

export default function loginForm() {
  const popUp = document.querySelector(".pop-up_login");

  if (!popUp) return;
  const statusPopUp = document.getElementById("pop-up");
  const statusMessage = statusPopUp.querySelector(".message");

  const openPopUp = document.querySelector("[data-login]");
  const closePopUp = popUp.querySelectorAll(".close_btn");

  const inputs = popUp.querySelectorAll(".input");
  const labels = popUp.querySelectorAll(".input_row");

  const loginButton = popUp.querySelector(".loginButton");

  function showPopUp() {
    stopScroll();
    popUp.classList.add("active");

    document.addEventListener("keydown", hideOnEscape);
    document.addEventListener("click", hideOnOutside);
  }

  function hidePopUp() {
    popUp.classList.remove("active");

    inputs.forEach((i) => (i.value = ""));
    labels.forEach((l) => l.classList.remove("error", "active"));

    document.removeEventListener("keydown", hideOnEscape);
    document.removeEventListener("click", hideOnOutside);

    startScroll();
  }

  // Close PopUp on Escape keydown
  function hideOnEscape(e) {
    if (e.key === "Escape") hidePopUp();
  }

  // Close PopUp on click outside Popup
  function hideOnOutside(e) {
    if (e.target.id == "pop-up_login") hidePopUp();
  }

  const onValidateError = (errors) => {
    Object.keys(errors).forEach((k) => {
      let input = [...inputs].filter((i) => i.dataset.type === k);
      let label = input[0].closest("label");
      label.classList.add("error");
      label.querySelector(".tip").innerHTML = errors[k];
    });
  };

  const onError = (error) => {
    hidePopUp();
    statusPopUp.classList.add("active", "error", "error_login");
    statusMessage.innerHTML = error;
  };

  // Send form via AJAX
  const sendForm = () => {
    loginButton.disabled = true;

    // Form data
    let data = new FormData();
    data.append("action", "userLogIn");
    inputs.forEach((i) => data.append(i.dataset.type, i.value));
    labels.forEach((l) => l.classList.remove("error"));

    // Send request
    fetch(BAMBOO.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        loginButton.disabled = false;

        if (data.error) {
          onError(data.error);
          // console.log(data.error);
        } else if (data.errors) {
          onValidateError(data.errors.fields);
        } else if (data.success) {
          location.reload();
        } else {
          // console.log(data);
          onError("Something went wrong. Please try again later or contact your manager")
        }
      })
      .catch((err) => {
        loginButton.disabled = false;
        console.log(err);
      });
  };

  function onInput(input) {
    input.addEventListener("input", () => {
      let label = input.closest("label");
      let err = label.classList.contains("error");
      let v = input.value;
      if (err) label.classList.remove("error");
      label.classList.toggle("active", v);
    });
  }

  inputs.forEach((i) => onInput(i));
  [...closePopUp].forEach((b) => b.addEventListener("click", hidePopUp));
  openPopUp.addEventListener("click", showPopUp);
  loginButton.addEventListener("click", sendForm);
}
